import { z } from "zod";
const isDevelopment = process.env.NODE_ENV === "development";
/**
 * 개발 모드에서만 Zod 스키마 검증을 수행하는 유틸리티 함수
 * safeParse를 사용하여 검증 실패 시에도 데이터를 반환한다 (경고만 출력)
 */
export const validateWithSchema = (schema, data) => {
    if (isDevelopment) {
        const result = schema.safeParse(data);
        if (!result.success) {
            console.warn("Zod 스키마 검증 실패:", result.error.issues);
        }
    }
    return data;
};
/**
 * 배열 데이터에 대한 Zod 스키마 검증 유틸리티 함수
 * safeParse를 사용하여 검증 실패 시에도 데이터를 반환한다 (경고만 출력)
 */
export const validateArrayWithSchema = (schema, data) => {
    if (isDevelopment) {
        const result = z.array(schema).safeParse(data);
        if (!result.success) {
            console.warn("Zod 스키마 검증 실패:", result.error.issues);
        }
    }
    return data;
};
